import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';


@Component({
  selector: 'app-search-alerts',
  templateUrl: './search-alerts.component.html',
  styleUrl: './search-alerts.component.css'
})
export class SearchAlertsComponent implements OnInit {

  authToken = localStorage.getItem('auth');
  businessID = this.route.snapshot.params.businessID;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  ngOnInit(): void {
    this.fetchAlerts();
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private authService: AuthService) { }

  alerts: any = [];

  fetchAlerts() {
    this.http.get(environment.SEARCH_ALERTS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.alerts = res.message;
        }
      }, (err: any) => {
        console.log("Error while finding status :: ", err);
      })
  }

}
